import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { ExternalLibraryService } from 'src/app/util';
import { UmsService } from '../ums.service';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { log } from 'console';
import * as CryptoJS from 'crypto-js';
import { HttpErrorResponse } from '@angular/common/http';
declare let Razorpay: any;
@Component({
  selector: 'app-razorpay-pay',
  templateUrl: './razorpay-pay.component.html',
  styleUrls: ['./razorpay-pay.component.scss']
})
 
export class RazorpayPayComponent implements OnInit {
  PayDetails: any;
  id: any;
  amount: any;
  dialogRef: MatDialogRef<any>;
  constructor(private razorpayService: ExternalLibraryService, public router: Router,
    private cd: ChangeDetectorRef, private elRef: ElementRef,
    private modalPopupService: ModalpopService,public dialog1: MatDialog,
    public umsService: UmsService, private spinner: NgxSpinnerService,) { }
  name = 'Angular';
  response;
  razorpayResponse;
  showModal = false;
 
  RAZORPAY_OPTIONS = {
    "key": "rzp_test_NCkk8dd6aTdf0X",
    "amount": 0,
    "name": "",
    "order_id": "",
    "description": "",
    "image": "https://cdn.razorpay.com/logos/FkKIMIc03KQfBA_original.jpg",
    "prefill": {
      "name": "",
      "email": "",
      "contact": ""
    },
  };
  ngOnInit(): void {
    this.PayDetails = this.umsService.getpayDetails();
    this.RazorPayOrder(this.PayDetails)
  }
 
  RazorPayOrder(data) {
    this.spinner.show();
    const payload = {};
    payload['amount'] = data.paydata['PaidAmount'];
    payload['currency'] = 'INR';
    payload['StuId'] = parseInt( data.paydata['StuId']);
    payload['FeeType'] = data.paydata['FeeType'];
    payload['SnNo'] = parseInt(data.paydata['SnNo']);
    this.amount = data.paydata['PaidAmount'];
    this.umsService.RazorPayOrder(payload).subscribe((res) => {
      if(res.status == 'created'){
        this.spinner.hide();
        this.id = res.id;
        //return
        this.submitRazorpayForm(data, res.id)
      }
      else if(res.status == 'Changed'){
       let data = {}
       this.spinner.hide();
       data['message'] = 'Mismatched Amount'
       data['title'] = 'Error'
       data['icon'] = 'fas fa-box-open'
       this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
       this.dialogRef.afterClosed().subscribe((result) => {
         window.location.reload();
        //this.router.navigate(['/home']);
       });
        
      }
     

    }, (ERROR: HttpErrorResponse) => {
     //his.router.navigate(['Fees']);
      window.location.reload();
        }
  )
  }
 
  submitRazorpayForm(data,id) {
    const encryptionKey = 'abc123';
    let encryptedPaydata = CryptoJS.AES.encrypt(
      JSON.stringify(data.paydata),
      encryptionKey
    ).toString();
     encryptedPaydata = encryptedPaydata.replace(/\//g, '~');
    // Create the form element
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = 'https://api.razorpay.com/v1/checkout/embedded';
 
    // Create hidden inputs for the form
    const fields = [
      { name: 'key_id', value: 'rzp_test_NCkk8dd6aTdf0X' },
      { name: 'amount', value: data.paydata['PaidAmount'] },
      { name: 'currency', value: 'INR' },
      { name: 'order_id', value: id },
      { name: 'name', value: '' },
      { name: 'description', value: '' },
      { name: 'image', value: '' },
      { name: 'prefill[name]', value: '' },
      { name: 'prefill[contact]', value: '' },
      { name: 'prefill[email]', value: '' },
      { name: 'notes[shipping address]', value: '' },
      { name: 'callback_url',    value: `http://192.168.1.2:1003/api/v1/payment/verify-payment/${encryptedPaydata}/${id}`},
     // { name: 'callback_url',    value: `http://192.168.1.2:1003/api/v1/payment/verify-payment/${encodeURIComponent(JSON.stringify(data.paydata))}`},
     // { name: 'callback_url',    value: `http://213.199.57.102:1003/api/v1/payment/verify-payment/${encryptedPaydata}/${id}`},
      { name: 'cancel_url', value: 'http://192.168.1.2:1003/api/v1/payment/callback' },
    ];
 
    // Append the hidden fields to the form
    fields.forEach(field => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = field.name;
      input.value = field.value;
      form.appendChild(input);
    });
 
    // Append the form to the body and submit it
    document.body.appendChild(form);
    form.submit();
    // this.savePaymentResponse(id);
  }
 
 
  verifyRazorPayOrder(data) {
    this.spinner.show();
    const payload = {};
    payload['payment_id'] = data.razorpay_payment_id;
    payload['order_id'] = data.razorpay_order_id;
    payload['signature'] = data.razorpay_signature;
    this.umsService.checkRazorPayOrder(payload).subscribe((res) => {
           this.getByIdRazorPayResponse(res)
 
    })
  }
 
 
  getByIdRazorPayResponse(data) {
    this.spinner.show();
    this.umsService.getRazorPayOrder(data.res.order_id).subscribe((res) => {
      this.saveRazorPayResponse(data,res);
      //this.savePaymentResponse(data, res)
    })
 
  }
 
  saveRazorPayResponse(data, item) {
    this.spinner.show();
    let payload = {};
    payload['payment_source'] = 'razorpay';
    payload['card_type'] = '';
    payload['mode'] = 'online';
    payload['email'] = '';
    payload['phone'] = '';
    payload['amount'] = this.PayDetails.paydata.PaidAmount;
    payload['stuid'] = parseInt(this.PayDetails.paydata.StuId);
    payload['FeeTempCode'] = this.PayDetails.paydata.FeeTemplateCode;
    payload['FeeType'] = this.PayDetails.paydata.FeeType;
    payload['SnNo'] = this.PayDetails.paydata.SnNo;
    payload['signature'] = data.signature;
    payload['payment_id'] = data.payment_id;
    payload['order_id'] = data.order_id;
    payload['status'] = 'success';
    this.umsService.saveRazorPayResponse(payload).subscribe((res) => {
      this.spinner.hide();
      // this.closeAllDialogs(this.PayDetails.paydata.FeeType);
    })
  }
 
 
  savePaymentResponse(data) {
    this.spinner.show();
    let payload = {};
    payload['payment_source'] = 'razorpay';
    payload['easepayid'] = data;
    payload['card_type'] = 'Card';
    payload['mode'] = 'online';
    payload['email'] = 'prachi@gmail.com';
    payload['phone'] = '9028309225'
    payload['key'] = data;
    payload['txnid'] = data;
    payload['status'] = 'success';
    payload['amount'] = this.PayDetails.paydata.PaidAmount;
    payload['StuId'] = parseInt(this.PayDetails.paydata.StuId);
    payload['FeeTemplateCode'] = this.PayDetails.paydata.FeeTemplateCode;
    payload['FeeType'] = this.PayDetails.paydata.FeeType;
    payload['SnNo'] = this.PayDetails.paydata.SnNo;
 
    this.umsService.savePaymentResponse(payload).subscribe((res) => {
    })
  }
 
}